import { makeStyles } from "@/utils"
import { colors } from "@/styles/colors"

const useStyles = makeStyles((theme) => ({
	card: {
		display: "flex",
		width: `calc(100% - ${theme.spacing(3)})`,
		alignItems: "center",
		justifyContent: "flex-start",
		backgroundColor: colors.purple[500],
		borderRadius: theme.spacing(1),
		padding: theme.spacing(1.25, 1.5),
		marginLeft: theme.spacing(1.5),
		marginRight: theme.spacing(1.5),
		gap: theme.spacing(1.25),
		cursor: "pointer",
		transition: theme.transitions.create(["background-color"], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.shortest
		}),
		"&:hover": { backgroundColor: colors.purple[600] }
	},
	cardSecondary: {
		backgroundColor: colors.purple[600],
		"&:hover": { backgroundColor: colors.purple[700] }
	},
	cardCollapsed: {
		margin: `${theme.spacing(0.75)} auto`,
		padding: theme.spacing(1),
		justifyContent: "center",
		alignSelf: "center",
		width: "fit-content"
	},
	iconBox: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: theme.spacing(4),
		height: theme.spacing(4),
		borderRadius: theme.spacing(0.625),
		backgroundColor: colors.purple[400],
		flexShrink: 0,
		color: colors.gray[0]
	},
	iconBoxSecondary: {
		backgroundColor: colors.purple[500],
		color: colors.gray[0]
	},
	textContainer: {
		flex: 1,
		minWidth: 0
	},
	instanceIdText: {
		color: colors.gray[0],
		lineHeight: 1.3,
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis"
	},
	instanceIdTextSecondary: {
		color: colors.gray[0]
	},
	instanceNameText: {
		color: colors.gray[0],
		fontWeight: 600,
		lineHeight: 1.3,
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis"
	},
	instanceNameTextSecondary: {
		color: colors.gray[0]
	},
	chevron: {
		flexShrink: 0,
		color: colors.gray[0]
	},
	chevronSecondary: {
		color: colors.gray[0]
	}
}))

export default useStyles
